import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

initializeDataDogSync();

bootstrapAngular();

// 🔧 FUNÇÃO: Inicialização DataDog SÍNCRONA
function initializeDataDogSync(): void {
  // Configuração síncrona
  try {
    const config = buildDataDogConfig();

    import('./app/core/util/dataDog/quickWebLogger')
      .then(({ QuickWebLoggerModule }) => {
        QuickWebLoggerModule.initializeRobustly(config)
          .then(() => console.log('[DataDog] ✅ DataDog ativo!'))
          .catch((error: any) => console.error('[DataDog] ❌ Erro:', error));
      })
      .catch((error) => {
        console.error('[DataDog] 🚨 Erro no import:', error);
      });
  } catch (error) {
    console.error('[DataDog] 🚨 Erro na configuração:', error);
  }
}

// 🚀 FUNÇÃO: Bootstrap Angular
function bootstrapAngular(): void {
  platformBrowserDynamic()
    .bootstrapModule(AppModule)
    .then((moduleRef) => {
      return moduleRef;
    })
    .catch((err) => {
      console.error('[App] ❌ Erro no bootstrap Angular:', err);
    });
}

function buildDataDogConfig(): any {
  return {
    name: environment.quickWebLogger?.name || 'plataforma-atacado',
    version: environment.quickWebLogger?.version || '1.0.0',
    env: environment.quickWebLogger?.env || 'hom',
    sigla: environment.quickWebLogger?.sigla || 'PA',
    externalApplication: environment.quickWebLogger?.externalApplication || false,
    clientToken: environment.quickWebLogger?.datadog?.logs?.clientToken || 'default-token',
    applicationId: environment.quickWebLogger?.datadog?.rum?.applicationId || 'default-app-id',
    sessionSampleRate: environment.quickWebLogger?.datadog?.rum?.sessionSampleRate || 100,
    maskSensitiveData: environment.quickWebLogger?.datadog?.rum?.maskSensitiveData !== false,
    allowedTracingUrls: environment.quickWebLogger?.datadog?.rum?.allowedTracingUrls || [],
    traceSampleRate: environment.quickWebLogger?.datadog?.rum?.traceSampleRate || 100,
    trackLongTasks: environment.quickWebLogger?.datadog?.rum?.trackLongTasks !== false,
    trackResources: environment.quickWebLogger?.datadog?.rum?.trackResources !== false,
    trackUserInteraction: environment.quickWebLogger?.datadog?.rum?.trackUserInteraction !== false
  };
}

/*
🎯 ARQUITETURA: DATADOG ANTES DO ANGULAR:
✅ DataDog inicializa PRIMEIRO (configuração síncrona)
✅ Angular bootstrap DEPOIS (sem interferência)
✅ Sem setTimeout prejudicial ao timing
✅ Sequência controlada: DataDog → Angular
✅ Zero impacto em Module Federation
*/
